module.exports = __webpack_public_path__ + "static/media/bank-of-mum-dad.7e9ac940.svg";